const t = {
  name: "CreditCard",
  dimensions: { width: 40, height: 26 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 26" style="enable-background:new 0 0 40 26;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M5,21h12v-2H5V21z"/>
		<path class="st0" d="M5,0C2.2,0,0,2.2,0,5v16c0,2.8,2.2,5,5,5h30c2.8,0,5-2.2,5-5V5c0-2.8-2.2-5-5-5H5z M2,5c0-1.7,1.3-3,3-3h30
			c1.7,0,3,1.3,3,3H2z M2,7h36v3H2V7z M2,21v-9h36v9c0,1.7-1.3,3-3,3H5C3.3,24,2,22.7,2,21z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as CreditCard
};
